export function concatenateAndTruncate(arr, maxLength, key) {
  const concatenatedString = arr
    .filter((item) => !!item[key])
    .map((item) => item[key])
    .join(" || ");

  if (concatenatedString.length <= maxLength) {
    return concatenatedString;
  } else {
    return concatenatedString.substring(0, maxLength) + "...";
  }
}

export function calculateReturnStatement(timestamp) {
  const now = new Date();
  const targetTime = new Date(timestamp);
  const timeDifference = Math.abs(now - targetTime) / 1000;

  const days = Math.floor(timeDifference / 86400);
  const hours = Math.floor((timeDifference % 86400) / 3600);
  const minutes = Math.floor((timeDifference % 3600) / 60);
  const seconds = Math.floor(timeDifference % 60);

  if (days > 0) {
    return `${days}d`;
  }

  if (hours > 0) {
    return `${hours}h`;
  }

  if (minutes > 0) {
    return `${minutes}m`;
  }

  return `${seconds}s`;
}

export const validateFile = (file, fileType, fileSize = 5) => {
  if (!(file && fileType && fileSize)) return;

  const type = file.type.split("/")[1];
  let validationRes = { errors: [] };

  switch (fileType) {
    case "image":
      if (!["png", "jpg", "jpeg"].includes(type))
        validationRes.errors.push("Upload png/jpg/jpeg image!");
      if (file.size / 1000000 > fileSize)
        validationRes.errors.push("Please upload size max of 5MB!");
      break;
    case "pdf":
      if (!["pdf"].includes(type))
        validationRes.errors.push("Upload pdf file!");
      if (file.size / 1000000 > fileSize)
        validationRes.errors.push("Please upload size max of 5MB!");
      break;
    case "video":
      if (file.type.split("/")[0] !== "video")
        validationRes.errors.push("Upload Video file!");
      if (!["mp4"].includes(type))
        validationRes.errors.push("Upload mp4 file!");
      //if(file.size/100000 > fileSize) validationRes.errors.push("Please upload size max of 5MB!");
      break;
    default:
      break;
  }

  return validationRes;
};
